const getters = {
  message: state => state.message.message
}
export default getters



// WEBPACK FOOTER //
// ./src/store/getters.js